/**
 *@阿拉伯语
 *@params
 *@author WangPing
 *@date 2020-07-20
 */

export default {
  _not_interested_in_this_video: '%second% لست مهتمًا بهذا الفيديو؟',
  _switch_one: 'آخر',
  _next_reward_text: 'Watch another video to earn', // 没有这个语言
  _next_reward_button: 'Play now', // 没有这个语言
  _just_for_you: 'Just for you', // 没有这个语言
  _recommend: 'Just for you',
}